import React, {useState} from 'react';
import leaderboard_art from '../../assets/images/leaderboard/leaderboard_art.png';
import close_icon from '../../assets/images/leaderboard/x.png';
import nail from '../../assets/images/leaderboard/nail.png';

const Leaderboard = ({setLeaderboard}) => {
    let leaderboard = [
        {
            rank: 5,
            wallet_address: "jokelsd",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 2,
            wallet_address: "YBnlXWMx7Gs9Z8gnZwAnuCwUFLATcaLYvWN72vpX8d",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 4,
            wallet_address: "Rinbbfp1zh8ESUJHEgTtgIlpl8i09hJ8cFCZnUm7Mi",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 3,
            wallet_address: "tEnh9vWZAVIpaUn4Dt1jLw4A12KpCBRqLyEtCI7yL6",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 1,
            wallet_address: "6ZYyE79JvEbfKfeHcb0uzHcSDJis1W1KA8atnbE5ue",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 7,
            wallet_address: "xe5tD7uDHmVmaFIbq3hwW8y7SgB8RRcxPMutlZc4bA",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 8,
            wallet_address: "0tXySRPH9ZJVvH1spH7MBs1ztUJVPaSLoH1tVu3Qpq",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 9,
            wallet_address: "4iQn7a2d3jSk8bv4oFmvQyuzmTGLCoENAI7KexjvDF",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 11,
            wallet_address: "1DxWqXy7GaVdrM2fOYxpeP03lKaM7eIxXrlMVirVpt",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 10,
            wallet_address: "TzYet4HLDuxX5aPudAz4iiRgJwSdL3mB6JGV2HijUO",
            staked_nfts: 15,
            earned_speed_cash: 1000000
        },
        {
            rank: 12,
            wallet_address: "gq38baFX9gLdjsBl6Xg48xgwk1vAGjHDItjYr080AM",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
        {
            rank: 13,
            wallet_address: "19TRYAmQs86aLoFIzKtsbsuDllBvADhSlLAbUpP4zl",
            staked_nfts: 13,
            earned_speed_cash: 10000
        },
        {
            rank: 14,
            wallet_address: "IpcqRZFmQIPzb9jrTAwSEOWCWQuqZdvF2zcWhyLyxM",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
        {
            rank: 15,
            wallet_address: "BGKsKp81rAIdCIJFiaNVXKzLD2LbUeKXJPBJ2H6SVb",
            staked_nfts: 13,
            earned_speed_cash: 10000
        },
        {
            rank: 16,
            wallet_address: "Y8AS8OYASIUHEZASOIY8AY8AS8OYASIUHEZASOIY8AS8OYASIUH",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
        {
            rank: 16,
            wallet_address: "Y8AS8OYASIUHEZASOIY8AY8AS8OYASIUHEZASOIY8AS8OYASIUH",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
        {
            rank: 16,
            wallet_address: "Y8AS8OYASIUHEZASOIY8AY8AS8OYASIUHEZASOIY8AS8OYASIUH",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
        {
            rank: 16,
            wallet_address: "Y8AS8OYASIUHEZASOIY8AY8AS8OYASIUHEZASOIY8AS8OYASIUH",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
        {
            rank: 16,
            wallet_address: "Y8AS8OYASIUHEZASOIY8AY8AS8OYASIUHEZASOIY8AS8OYASIUH",
            staked_nfts: 14,
            earned_speed_cash: 100000
        },
    ]
    const [searchTerm, setSearchTerm] = useState('');
    const editRankStr = (amount) => {
        return amount <= 9 && amount > 0 ? "0" + amount.toString() : amount
    }
    const handleSearch = (target) => {
        setSearchTerm(target.target.value);
    };

    const filteredData = leaderboard.filter((item) =>
        item.wallet_address.toLowerCase().includes(searchTerm.toLowerCase())
    ).sort((a, b) => a.rank - b.rank);

    const editAddressStr = (address) => {
        return address.slice(0, 5) + "..." + address.slice(-5)
    }

    const numberWithSpaces = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    return (
        <div className="fixed top-0 left-0 h-full w-full z-50 bg-[rgba(0,0,0,0.7)] appear-animation backdrop-blur">
            <div className="flex place-items-center justify-center w-screen h-screen z-60">
                <div className="w-5/6 h-5/6 relative leaderboard rounded-[15px] overflow-hidden">
                    <div className="relative z-10 flex">
                        <div className="p-4 lg:py-12 lg:px-28 flex lg:gap-20 flex-col grow">
                            <div className="flex flex-col lg:flex-row lg:justify-between">
                                <h1 className="text-[40px] text-white font-bernier">Leaderboard</h1>
                                <div>
                                    <input
                                        className="outline-none text-[18px] px-4 py-2 w-[250px] lg:w-[340px] placeholder-white font-gilroy rounded-[15px] bg-[rgba(255,255,255,0.2)]"
                                        placeholder="Search address" type="text" onChange={handleSearch}/>
                                </div>
                            </div>
                            <div className="hidden lg:block">
                                <div className="flex flex-col gap-4 text-[32px]">
                                    <div className="flex flex-row font-bold">
                                        <div className="w-1/4 p-2 opacity-60">Rank</div>
                                        <div className="w-1/4 p-2 opacity-60">Wallet address</div>
                                        <div className="w-1/4 p-2 opacity-60">Staked Nfts</div>
                                        <div className="w-1/4 p-2 opacity-60 text-end">earned speed cash</div>
                                    </div>
                                    <div className="overflow-y-scroll border-y-2 h-[450px]">
                                        {filteredData.map((item, index) => (
                                            <div key={index} className="flex justify-between items-center rounded-[10px] p-2 lb-table">
                                                <div className="w-[10%] text-white rounded-[8px]">{editRankStr(item.rank)}</div>
                                                <div className="w-[40%] text-white rounded-[8px] pl-16 text-center">{editAddressStr(item.wallet_address)}</div>
                                                <div className="w-[20%] text-white rounded-[8px] pl-5">{item.staked_nfts}</div>
                                                <div className="w-[30%] text-white text-end rounded-[8px]">{numberWithSpaces(item.earned_speed_cash)}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="overflow-y-scroll h-[500px] lg:hidden border-y-2 mt-5 pt-2">
                                {
                                    filteredData.map((item, index) => (
                                        <div key={index} className="flex rounded-[10px] p-2 text-[24px] flex-col lb-table">
                                            <div className="flex justify-between">
                                                <div>{editRankStr(item.rank)}</div>
                                                <div>{editAddressStr(item.wallet_address)}</div>
                                            </div>
                                            <div className="flex justify-between">
                                                <div className="opacity-50">Earned speed cash</div>
                                                <div>{item.earned_speed_cash}</div>
                                            </div>
                                            <div className="flex justify-between">
                                                <div className="opacity-50">Staked Nfts</div>
                                                <div>{item.staked_nfts}</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="w-[18%] hidden 2xl:block">
                            <img className="mt-[100%] w-[90%]" src={leaderboard_art} alt=""/>
                        </div>
                    </div>

                    {/*<div className="absolute top-[140px]  transform -translate-x-1/2 left-1/2 overflow-y-scroll w-[95%] max-h-[70%] lg:max-w-[80%] lg:max-h-[65%]">*/}
                    {/*    <table>*/}
                    {/*        <thead>*/}
                    {/*        <tr className="text-[rgba(255,255,255,0.6)] font-bernier font-light text-[32px]">*/}
                    {/*            <th className="text-start whitespace-nowrap pr-4 2xl:pr-28">Rank</th>*/}
                    {/*            <th className="text-start whitespace-nowrap pr-8 2xl:pr-28">Wallet Address</th>*/}
                    {/*            <th className="text-start whitespace-nowrap pr-4 2xl:pr-28">Staked NFTs</th>*/}
                    {/*            <th className="whitespace-nowrap pr-5">Earned Speed Cash</th>*/}
                    {/*        </tr>*/}
                    {/*        </thead>*/}
                    {/*        <tbody>*/}
                    {/*        {filteredData.map((item, index) => (*/}
                    {/*            <tr key={index} className="font-bernier text-[28px] rounded-[10px] lb-table">*/}
                    {/*                <td className="w-[10%] text-white rounded-[8px] pl-1">{editRankStr(item.rank)}</td>*/}
                    {/*                <td className="w-[30%] text-white rounded-[8px]">{editAddressStr(item.wallet_address)}</td>*/}
                    {/*                <td className="w-[30%] text-white rounded-[8px]">{item.staked_nfts}</td>*/}
                    {/*                <td className="w-[30%] text-white text-end pr-5">{item.earned_speed_cash}</td>*/}
                    {/*            </tr>*/}
                    {/*        ))}*/}
                    {/*        </tbody>*/}
                    {/*    </table>*/}
                    {/*</div>*/}

                    <div>
                        <img className="absolute lg:block hidden top-[20px] left-[20px]" src={nail} alt=""/>
                        <img className="absolute lg:block hidden bottom-[20px] left-[20px]" src={nail} alt=""/>
                        <img className="absolute lg:block hidden bottom-[20px] right-[20px]" src={nail} alt=""/>
                        <img className="absolute z-10 top-[20px] right-[20px] border-2 rounded-full w-[23px] cursor-pointer"
                             src={close_icon}
                             alt="" onClick={() => setLeaderboard(false)}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Leaderboard;